import React from "react";
import { Row, Col, Input, Switch, Icon } from "antd";
import useStockItemContext from "../../../hooks/useStockItemContext";
import { useSelector } from "react-redux";
import StockItemSummaryCards from "./StockItemSummaryCards";
import StockItemTable from "./StockItemTable";
import StockItemDetailDrawer from "./StockItemDetailDrawer";
import ButtonStandard from "../../../components/utils/button";
import DrawerManufacturer from "../../../components/drawers/manufacturer";
import UnitForm from "../../unit/form";

const { Search } = Input;

const StockItemsTab = () => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.stockItem || {};

  const {
    searchTerm,
    showInactive,
    handleSearch,
    handleToggleInactive,
    handleOpenNewItem,
    handleRefresh,
  } = useStockItemContext();

  return (
    <>
      <Row
        gutter={16}
        style={{ marginBottom: 16 }}
        type="flex"
        align="middle"
        justify="space-between"
      >
        <Col>
          <Search
            value={searchTerm}
            placeholder={
              t.searchPlaceholder || "Buscar por ID, abreviação ou descrição..."
            }
            onChange={(e) => handleSearch(e.target.value)}
            onSearch={handleSearch}
            style={{ width: 320 }}
            allowClear
          />
        </Col>
        <Col>
          <Row
            type="flex"
            justify="end"
            align="middle"
            gutter={8}
            style={{ marginTop: 8 }}
          >
            <Col>
              <span style={{ marginRight: 4 }}>
                {showInactive
                  ? t.toggleInactive || "Inativos"
                  : t.toggleActive || "Ativos"}
              </span>
              <Switch
                checked={showInactive}
                onChange={handleToggleInactive}
                size="small"
              />
            </Col>
            <Col>
              <ButtonStandard
                buttonType="typeWithoutBackground"
                onClick={handleRefresh}
              >
                <Icon type="reload" />
              </ButtonStandard>
            </Col>
            <Col>
              <ButtonStandard
                type="button"
                buttonType="addNew"
                onClick={handleOpenNewItem}
              >
                {t.newItem || "Novo Item"}
              </ButtonStandard>
            </Col>
          </Row>
        </Col>
      </Row>

      <StockItemSummaryCards />
      <StockItemTable />
      <StockItemDetailDrawer />
      <DrawerManufacturer />
      <UnitForm />
    </>
  );
};

export default StockItemsTab;
